export const getParameterName = (parameter) => {
    if (parameter.context.effect) {
        return parameter.context.effect.name + ' - ' + parameter.prettyName;
    }

    if (parameter.context.midiEffect) {
        return parameter.context.midiEffect.name + ' - ' + parameter.prettyName;
    }
    
    if (parameter.context.macro) {
        return parameter.context.macro.name;
    }

    if (parameter.context.subDevice) {
        if (parameter.context.instrument) {
            let inst = parameter.context.instrument;
            let index = inst.getSubDeviceIndex(parameter.context.subDevice);
            let subDevices = inst.getSubDevices();
                if (subDevices[index]) {
                    let subDeviceName = subDevices[index].label;
                    return subDeviceName + ' - ' + parameter.prettyName;
                }
        }
    }
    
    return parameter.prettyName;
};

